<template>
  <div class="container">
    <!-- 选择网吧   -->
    <div
      class="selectBar-list"
      v-for="item in selectList"
      :key="item.internetBarId"
      @click="handleChooseBarCLick(item.internetBarId)"
    >
      <span>{{ item.site_name }}</span>
      <img
        src="@/images/choosebar.png"
        v-show="selectId == item.internetBarId"
        alt
        srcset
      />
    </div>

    <div class="plbm-btn" @click="handleSubmitClick">提交</div>
  </div>
</template>

<script>
import { chooseBarList, selectUserInformation } from "@/api/index";
import { Toast } from "vant";
export default {
  data() {
    return {
      selectId: "",
      selectList: [],
    };
  },
  created() {
    this.requestChooseBarList();
  },
  methods: {
    requestChooseBarList() {
      chooseBarList().then((res) => {
        console.log(res);
        if (res.data.length == 1) {
          this.$cookies.set("internetBarId", res.data[0].internetBarId);
          this.$router.push("/");
        } else {
          this.selectList = res.data;
        }
      });
    },
    requestSelectUserInformation(internetBarId) {
      if (!internetBarId) {
        Toast("请先选择网吧");
        return false;
      }
      this.$cookies.set("internetBarId", internetBarId);
      // sessionStorage.setItem("internetBarId", internetBarId);
      selectUserInformation({ internetBarId: internetBarId }).then((res) => {
        if (res.code == 200) {
          // console.log(this.$route.query)
          sessionStorage.setItem("loginInfo", JSON.stringify(res.data));
          if (this.$route.query.url == "/writewarranty") {
            this.$router.push({
              path: "/writewarranty",
            });
          } else if (this.$route.query.url == "/consultnew") {
            this.$router.push({
              path: "/consultnew",
            });
          } else {
            this.$router.push({
              path: "/",
            });
          }
        }
      });
    },
    handleChooseBarCLick(id) {
      console.log(id);
      this.selectId = id;
    },
    handleSubmitClick() {
      const url = this.$route.query.url;
      if (url == "/integral") {
        console.log("111");
        this.$router.replace({
          path: url,
          query: {
            id: this.selectId,
          },
        });
      } else {
        this.requestSelectUserInformation(this.selectId);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;

  .selectBar-list {
    width: 100%;
    height: 50px;
    text-align: left;
    line-height: 50px;
    // margin: 0 auto;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 15px;
    border-bottom: 1px solid #f2f2f2;
    background-color: #ffffff;
    img {
      width: 18px;
      height: 11px;
      float: right;
      margin-top: 20px;
    }
  }
  .plbm-btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    margin: 0 auto;
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    margin: 20px auto;
  }
}
</style>
